/**
 * Platform-Level Module Configuration
 *
 * Platform modules (Prospecting: leads, campaigns, inbox) are owned by
 * Frankly Advisors and visible to any user who has the Frankly Advisors
 * brand in their assigned brands -- regardless of which brand is currently
 * active.  They are NOT gated by per-brand module access toggles.
 *
 * Deal modules (accounts, seller_opps, matches, etc.) remain brand-scoped.
 */

import type { ModuleName } from '@/hooks/useModulePermissions';

/**
 * Slug used to identify the Frankly Advisors brand in the brands table.
 * This avoids hardcoding a UUID and is resilient across environments.
 */
export const FRANKLY_BRAND_SLUG = 'fba';

/**
 * Modules that are platform-level (Prospecting section).
 * Visibility requires Frankly Advisors brand access + user module permissions.
 * These modules ignore the active brand's module access toggles.
 */
export const PLATFORM_MODULES: ReadonlySet<ModuleName> = new Set([
  'leads',
  'campaigns',
  'inbox',
]);

/** Type guard: is this module platform-level? */
export function isPlatformModule(module: ModuleName): boolean {
  return PLATFORM_MODULES.has(module);
}
